import { useEffect, useState } from 'react';
import { useApp } from 'context/AppContext';
import { Offers } from 'components';
import storeService from 'services/store.service';
import { Banner, Container } from './Styles';

const Store = ({ data: storeData }) => {
  const { state, setStoreData } = useApp();
  const { storeEvent } = state;
  const [assetsLoaded, setAssetsLoaded] = useState(false);

  useEffect(() => {
    if (storeData) {
      setStoreData({ store: storeData });
    }
  }, [storeData, setStoreData]);

  useEffect(() => {
    setAssetsLoaded(false);
    const bannerUrl = storeService.getBanner({ event: storeEvent, data: storeData.evs });
    if (!bannerUrl) {
      setAssetsLoaded(true);
      return;
    }
    const img = new Image();
    img.src = bannerUrl;
    img.onload = () => setAssetsLoaded(true);
    img.onerror = () => {
      console.error('Failed to load banner asset:', bannerUrl);
      setAssetsLoaded(true);
    };
  }, [storeData, storeEvent]);

  const getBanner = () => storeService.getBanner({ event: storeEvent, data: storeData.evs });

  return (
    <Container $assetsLoaded={assetsLoaded}>
      <Banner $banner={getBanner()} />
      <Offers store={storeData} />
    </Container>
  );
};

export default Store;
